import React from "react";
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';

const DienstleistungenHeader = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="mainbanner">
        <div className="digital-agency-banner">
          <div className="container">
            <div className="digital-agency-banner-content">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
              >
                {t('dienstleistungen_header_title')}
              </h1>

              <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1200">
                {t('dienstleistungen_header_description')}
              </p>

              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                <Link href="/kontakt" className="default-btn">
                  <i className="bx bxs-envelopet"></i>{t('dienstleistungen_header_contact_button')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DienstleistungenHeader;
